/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  CopyOutlined,
  LinkOutlined,
  MailOutlined,
  ShareAltOutlined,
  WhatsAppOutlined,
} from '@ant-design/icons'
import {
  Alert,
  Button,
  Col,
  Divider,
  message,
  Modal,
  Space,
  Tooltip,
} from 'antd'
import React, { useState } from 'react'
import { FaTelegramPlane } from 'react-icons/fa'
import { ShareLinkButton } from '~/components/DefaultLayout/Buttons/buttonStyle'
import { useCompanies } from '~/hooks/Companies/useCompanies'
import { useTask } from '~/hooks/Tasks/useTask'
import api from '~/services/api'
import { translate } from '~/utils/locale'

const LinkTask: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [shortLink, setShortLink] = useState('')
  const [loading, setLoading] = useState(false)

  const { task } = useTask()

  const { selectedCompany } = useCompanies()

  const linkTask = `https://tasks.gstor.com.br/?auth=${selectedCompany},${task?.responsible?.id}`

  const showModal = async () => {
    setIsModalVisible(true)
  }

  const closeModal = () => {
    setIsModalVisible(false)
  }

  const generateLink = async () => {
    try {
      setLoading(true)
      const response = await api.post(`company/${selectedCompany}/shortLink`, {
        originalUrl: linkTask,
      })
      const { shortId } = response.data

      const short = `https://api.gstor.com.br/s/${shortId}`
      setShortLink(short)
    } catch (err: any) {
      message.error('Erro ao gerar link.')
    } finally {
      setLoading(false)
    }
  }

  const copyToClipboard = async () => {
    navigator.clipboard.writeText(shortLink)
    message.success(translate('TasksTabsDetailsLink.messageSuccess'))
  }

  console.log(shortLink)

  return (
    <>
      <Tooltip title={translate('TasksTabsDetailsLink.tooltipTitle')}>
        <ShareLinkButton icon={<ShareAltOutlined />} onClick={showModal} />
      </Tooltip>

      <Modal
        title={
          <>
            {translate('TasksTabsDetailsLink.modalTitle')}
            <Divider style={{ margin: '10px 0' }} />
          </>
        }
        open={isModalVisible}
        onOk={closeModal}
        onCancel={closeModal}
        width="600px"
        footer={null}
      >
        {shortLink ? (
          <Col>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                marginTop: 20,
              }}
            >
              <Alert
                message="Link gerado com sucesso!"
                description={shortLink}
                type="success"
                showIcon
              />
              <Tooltip title={translate('TasksTabsDetailsLink.whatsapp')}>
                <Space direction="vertical" align="center">
                  <Button
                    ghost
                    type="primary"
                    shape="circle"
                    icon={<WhatsAppOutlined />}
                    href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
                      linkTask,
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                </Space>
              </Tooltip>

              <Tooltip title={translate('TasksTabsDetailsLink.telegram')}>
                <Space direction="vertical" align="center">
                  <Button
                    ghost
                    type="primary"
                    shape="circle"
                    icon={<FaTelegramPlane />}
                    href={`https://telegram.me/share/url?url=${encodeURIComponent(
                      linkTask,
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                </Space>
              </Tooltip>

              <Tooltip title={translate('TasksTabsDetailsLink.email')}>
                <Space direction="vertical" align="center">
                  <Button
                    ghost
                    type="primary"
                    shape="circle"
                    icon={<MailOutlined />}
                    href={`mailto:?subject=Confira este link&body=${encodeURIComponent(
                      linkTask,
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  />
                </Space>
              </Tooltip>

              <Tooltip title={translate('TasksTabsDetailsLink.copyText')}>
                <Space direction="vertical" align="center">
                  <Button
                    ghost
                    type="primary"
                    shape="circle"
                    icon={<CopyOutlined />}
                    onClick={copyToClipboard}
                  />
                </Space>
              </Tooltip>
            </div>
          </Col>
        ) : (
          <ShareLinkButton
            type="primary"
            icon={<LinkOutlined />}
            onClick={generateLink}
            loading={loading}
            style={{ width: '100%' }}
          >
            Gerar Link
          </ShareLinkButton>
        )}
      </Modal>
    </>
  )
}

export default LinkTask
